import React, { useState } from "react";

import {
  Box,
  Typography,
  TextField,
  Link,
  CircularProgress,
} from "@mui/material";
import SubmitButton from "../Buttons/SubmitButton";
import { toast } from "react-toastify";
import {
  useForgotPasswordMutation,
  useResetPasswordMutation,
} from "../../store/api";

const ForgetPassword = ({ onBack }) => {
  const [forgotPassword] = useForgotPasswordMutation();
  const [resetPassword] = useResetPasswordMutation();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (step === 1) {
        await forgotPassword({
          type: "email",
          value: email,
        }).unwrap();

        toast.success("OTP sent to your email");
        setStep(2);
      } else {
        await resetPassword({
          type: "email",
          value: email,
          otp,
          password,
          password_confirmation: confirmPassword,
        }).unwrap();

        toast.success("Password reset successfully");
        onBack();
      }
    } catch (error) {
      toast.error(error?.data?.message || error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 4,
        borderRadius: 4,
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth: 400,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      <Box
        component="img"
        src="/images/revivebussiness-loogo.png"
        alt="Company Logo"
        sx={{ width: 140 }}
      />

      <Typography variant="h5" fontWeight={700}>
        {step === 1 ? "Forgot Password" : "Reset Password"}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {step === 1
          ? "Enter your email to receive OTP"
          : "Enter OTP and new password"}
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <TextField
          fullWidth
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {step === 2 && (
          <>
            <TextField
              label="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <TextField
              label="New Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <TextField
              label="Confirm Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </>
        )}

        <SubmitButton disabled={loading}>
          {loading ? (
            <>
              <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
              {step === 1 ? "Sending OTP..." : "Resetting..."}
            </>
          ) : step === 1 ? (
            "Send OTP"
          ) : (
            "Reset Password"
          )}
        </SubmitButton>
      </Box>

      <Link
        component="button"
        onClick={onBack}
        sx={{ textDecoration: "underline" }}
      >
        Back to Sign In
      </Link>
    </Box>
  );
};

export default ForgetPassword;
